module.exports = __webpack_public_path__ + "a9a9bec14d402ed4bd924c23bdbd21b7.svg";